
import {useQuery} from "@tanstack/react-query";
import axiosManager from "../services/axiosManager";

export const useGetRelationships = () => {
    const {
        isFetching: isLoading, data: relationships, error,
    } = useQuery({
        queryKey: ["relationships"],
        queryFn: () => axiosManager.get$("relationships").then((response) => response?.data),
        initialData: [],
        retry: 0,
    });

    const relationshipsOptions = (relationships || []).map((item) => ({value: item.relationshipTypeId, label: item.displayName}));

    return {
        isLoading, relationships, error, relationshipsOptions,
    };

};
